import { ExternalLink, RefreshCw } from 'lucide-react'
import type { FibuUebergabe } from '../../lib/api'
import { formatCurrency } from '../../lib/format'

function statusText(u: FibuUebergabe): string {
  if (u.status === 'abgerechnet') return 'Festgeschrieben'
  if (u.status === 'in_abrechnung') return 'Entwurf'
  if (u.status === 'offen') return 'Ausgang unklar'
  if (u.status === 'storniert') return 'Storniert'
  return 'Freigegeben'
}

export function FibuUebergabenListe({
  uebergaben,
  kundenNamen,
  onAbgleich,
}: {
  uebergaben: FibuUebergabe[]
  kundenNamen: Record<string, string>
  onAbgleich: (id: string) => void
}) {
  if (!uebergaben.length) return null
  return (
    <section className="space-y-3" aria-label="Übergaben an emberfibu">
      <h2 className="text-lg font-medium text-text-primary">Übergaben an emberfibu</h2>
      <div className="grid gap-2">
        {uebergaben.map((u) => (
          <article
            key={u.id}
            className="rounded-xl border border-border-default bg-bg-elevated/40 p-4 text-sm"
          >
            <div className="flex flex-wrap items-start justify-between gap-2">
              <div>
                <div className="font-medium text-text-primary">
                  {u.fibuNummer ??
                    `Übergabe vom ${new Date(u.createdAt).toLocaleDateString('de-DE')}`}
                </div>
                <div className="text-text-secondary">
                  {kundenNamen[u.customerId] ?? u.kundennummer} · {u.firma.name}
                </div>
              </div>
              <span className="rounded-full bg-bg-overlay px-2 py-1 text-xs text-text-secondary">
                {statusText(u)}
              </span>
            </div>
            <div className="mt-2 text-text-secondary">
              {u.zeiten} Zeiten · {u.leistungVon}–{u.leistungBis} ·{' '}
              {formatCurrency(u.bruttoCent ?? 0)}
            </div>
            <div className="mt-3 flex flex-wrap gap-3">
              {u.oeffnenUrl && (
                <a
                  className="inline-flex items-center gap-1 text-accent hover:underline"
                  href={u.oeffnenUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  In emberfibu öffnen <ExternalLink className="h-3.5 w-3.5" />
                </a>
              )}
              {u.fibuRechnungId && u.status === 'in_abrechnung' && (
                <button
                  type="button"
                  className="inline-flex items-center gap-1 text-text-secondary hover:text-accent"
                  onClick={() => onAbgleich(u.id)}
                >
                  <RefreshCw className="h-3.5 w-3.5" /> Status abgleichen
                </button>
              )}
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}
